export type SectionImage = {
  src: string
  alt: string
  caption: string
}

export const heroImage: SectionImage = {
  src: 'https://cdn.magicpatterns.com/patterns/generated-images/2ea63924-ef75-4dd4-9d80-6a178caa4f78.jpg',
  alt: 'Mujer de unos 43 años en su cocina de noche, con las manos sobre el abdomen hinchado junto a un plato de verduras',
  caption:
    'Muchas mujeres de más de 35 describen la misma escena: una cena «liviana» y, al rato, el abdomen tenso. Foto ilustrativa.',
}

export const sectionImages: Record<'microbiota' | 'clock' | 'digestion' | 'choice', SectionImage> = {
  microbiota: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/4ffa5a93-4d66-4218-b5b5-ca5772b8d687.jpg',
    alt: 'Ilustración del intestino con bacterias beneficiosas de un lado y bacterias desequilibradas del otro',
    caption:
      'La microbiota funciona como un ecosistema: cuanto más diverso y equilibrado, mejor colabora con la digestión. Ilustración.',
  },
  clock: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/a9129dd7-294f-4c7e-9eee-e5f209deec2f.jpg',
    alt: 'Reloj marcando las 9 junto a platos fríos y crudos a un lado y platos calientes y cocidos al otro',
    caption:
      'A las 9 de la noche, el cuerpo ya empieza a bajar revoluciones. Lo que ponemos en el plato puede acompañar ese cambio… o ir en contra. Foto ilustrativa.',
  },
  digestion: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/593ad03c-8515-4184-b2ad-d704b22ffa75.jpg',
    alt: 'Gráfico sencillo de digestión lenta con estómago e intestino y alimentos sin procesar',
    caption:
      'Cuando la digestión se vuelve lenta, parte de la comida llega al intestino sin estar bien procesada. Ilustración.',
  },
  choice: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/941e3dff-f00d-4ef3-aa09-0ad511967d97.jpg',
    alt: 'Mujer de más de 35 años mirando dos opciones de cena: una fría y cruda, otra caliente y simple',
    caption:
      'La pregunta no es solo cuántas calorías tiene, sino si tu cuerpo puede digerirlo fácilmente mientras descansa. Foto ilustrativa.',
  },
}
